import { render, staticRenderFns } from "./DeliveryFormId.vue?vue&type=template&id=4cbf5e91&scoped=true&lang=pug&"
import script from "./DeliveryFormId.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormId.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFormId.vue?vue&type=style&index=0&id=4cbf5e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf5e91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
